import React from 'react';
import type { PrequelArtId } from '../../data/prequel';
interface PrequelArtProps {
  panel: PrequelArtId;
  label: string;
}
const PANEL_IMAGES: Record<PrequelArtId, string> = {
  mirror: 'https://cdn.magicpatterns.com/patterns/generated-images/15ec4222-22ec-49c4-a04d-7b93e502e29f.jpg',
  question: 'https://cdn.magicpatterns.com/patterns/generated-images/9d2a721f-c64d-46bc-8283-4bafd30494f1.jpg',
  sounds: 'https://cdn.magicpatterns.com/patterns/generated-images/9f6acbaf-9457-4ef1-96b5-ca4c46e88a70.jpg',
  purr: 'https://cdn.magicpatterns.com/patterns/generated-images/3a7392da-e62d-4ffa-8f8a-2c1fcade246d.jpg',
  glow: 'https://cdn.magicpatterns.com/patterns/generated-images/9e2d6aed-9cf7-469e-991e-e98546e90fff.jpg',
  accept: 'https://cdn.magicpatterns.com/patterns/generated-images/03512a61-6f16-44dd-a2fd-5714e8e49265.jpg'
};
export function PrequelArt({
  panel,
  label
}: PrequelArtProps) {
  return <div className="aspect-[16/9] w-full overflow-hidden bg-[#3a3a32]" data-id="element-12" data-mp="2v9awwgd60gyz">
      <img src={PANEL_IMAGES[panel]} alt={label} width={1376} height={768} decoding="async" className="block h-full w-full object-cover" data-id="element-13" data-mp="1szpe6pdga4sw" />
    </div>;
}